// extracted by mini-css-extract-plugin
export default {"contentWrapper":"AssetsReports_contentWrapper__8Wz8n","errorContainer":"AssetsReports_errorContainer__8e9DK"};